document.addEventListener('DOMContentLoaded', function () {
  var $comparison = $('.switch-comparison .comparison-box');
  if (!$comparison.length) return;

  var audioLen = $comparison.find('audio').length;
  for (var i = 1; i <= audioLen; i++) {
    var endedPlayer = document.getElementById('player-' + i);
    if (!endedPlayer) continue;
    endedPlayer.onended = function () {
      $('.comparison-box .product-audio-btn .btn-graphic-ctn .soundwave-active').removeClass('playing');
      $('.comparison-box .audio-player').attr('aria-pressed', 'false');
    };
  }

  function toggleAudioPlayer($player) {
    var clickId = $player.attr('data-id');
    var audioElement = document.getElementById('player-' + clickId);
    var soundWave = $player.find('.soundwave-active');
    if (!audioElement) return;
    if (audioElement.paused) {
      for (var j = 1; j <= audioLen; j++) {
        var tempPlayer = document.getElementById('player-' + j);
        if (tempPlayer) tempPlayer.pause();
      }
      $('.comparison-box .product-audio-btn .btn-graphic-ctn .soundwave-active').removeClass('playing');
      $('.comparison-box .audio-player').attr('aria-pressed', 'false');
      soundWave.addClass('playing');
      $player.attr('aria-pressed', 'true');
      audioElement.play();
    } else {
      audioElement.pause();
      $('.comparison-box .product-audio-btn .btn-graphic-ctn .soundwave-active').removeClass('playing');
      $player.attr('aria-pressed', 'false');
      audioElement.currentTime = 0;
    }
  }

  $('.switch-comparison .comparison-box .audio-player').on('click', function () {
    toggleAudioPlayer($(this));
  });

  var elem = $('.comparison-box .filter-values .scroller')[0];
  if (!elem) return;

  var $prevBtn = $('.comparison-box .scroll-bar .toggle-btn.prev-btn');
  var $nextBtn = $('.comparison-box .scroll-bar .toggle-btn.next-btn');
  var scrollDistance = elem.scrollWidth - elem.clientWidth;
  var perDistance = 150;
  var currScroll = 0;

  function setScrollBtnState($btn, isDisabled) {
    $btn.toggleClass('disabled', isDisabled);
    $btn.prop('disabled', isDisabled);
  }

  function updateScrollButtons() {
    if (elem.scrollLeft <= 0) {
      setScrollBtnState($prevBtn, true);
    } else {
      setScrollBtnState($prevBtn, false);
    }
    if (elem.scrollLeft + elem.clientWidth >= elem.scrollWidth - 1) {
      setScrollBtnState($nextBtn, true);
    } else {
      setScrollBtnState($nextBtn, false);
    }
    currScroll = elem.scrollLeft;
  }

  if (scrollDistance > 0) {
    $('.comparison-box .filter-values .scroller').on('scroll', updateScrollButtons);
    updateScrollButtons();
  } else {
    setScrollBtnState($prevBtn, true);
    setScrollBtnState($nextBtn, true);
  }

  $('.comparison-box .scroll-bar .toggle-btn').on('click', function () {
    var $btn = $(this);
    if ($btn.prop('disabled') || $btn.hasClass('disabled')) return;

    if ($btn.hasClass('prev-btn')) {
      currScroll = currScroll >= perDistance ? currScroll - perDistance : 0;
    } else if (currScroll < scrollDistance && scrollDistance - currScroll >= perDistance) {
      currScroll = currScroll + perDistance;
    } else {
      currScroll = scrollDistance;
    }

    $('.comparison-box .filter-values .scroller').animate({ scrollLeft: currScroll + 'px' }, 100);
  });
});
